import ExistingContacts from 'components/contacts/ExistingContacts';
import React from 'react';

function RecipientPage() {
  return (
    <div className="leftContent">
      <ExistingContacts />
    </div>
  );
}

export default RecipientPage;
